"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YEARS = exports.MONTHS = void 0;
var MONTHS = exports.MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var YEARS = exports.YEARS = [2019, 2020, 2021, 2022];